export const getAllocationBanExpiredAt = (account = {}) => {
    const nestedAccounts = Array.isArray(account.account_list)
        ? account.account_list
        : [];
    const candidates = [
        account.allocation_ban_expired_at,
        account.voiceAccount?.allocation_ban_expired_at,
        account.smsAccount?.allocation_ban_expired_at,
        ...nestedAccounts.map(item => item.allocation_ban_expired_at)
    ];

    return candidates.find(value => value != null) ?? null;
};
